"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[17455],{

/***/ 20789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var _material_ui_core_OutlinedInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74061);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);








var StyledP2 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("p", {
    target: "ena7kom0",
    label: "StyledP2"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.SEMIBOLD */ .F3.rX, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.P2 */ .F3.P2, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.HEADER_LINE_HEIGHT */ .F3.rm, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_2B */ .t8.Rw, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.mobile */ .AV.mobile, "){font-size:10px;}");
var StyledTextField = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_OutlinedInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "ena7kom1",
    label: "StyledTextField"
})("&.MuiOutlinedInput-root{border-style:solid;border-width:1px;border-color:var(--color-divider);border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_6 */ .t8.A1, ";transition:border-color 400ms ease-in-out;", function(param) {
    var $width = param.$width;
    if ($width) {
        return "width: ".concat($width, ";");
    }
}, "    .MuiOutlinedInput-input{padding:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_4B */ .t8.BM, " ", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_6B */ .t8.BY, ";::-webkit-input-placeholder,::-moz-placeholder,::placeholder{color:var(--color-text-secondary);opacity:1;}}}&.MuiOutlinedInput-multiline{padding:0px;}&.MuiOutlinedInput-adornedEnd{padding-right:30px;}&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline{display:none;pointer-events:none;}&:hover.MuiOutlinedInput-root:not(.Mui-disabled):not(.Mui-focused){border-color:var(--color-text-primary);}&.MuiOutlinedInput-root.Mui-focused{border-color:var(--color-text-primary);border-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .PRIMARY_BORDER_WIDTH */ .UK, ";}&.MuiOutlinedInput-root.MuiOutlinedInput-colorSecondary{border-color:var(--color-i-green);}&.MuiOutlinedInput-root.Mui-error{border-color:var(--color-i-red);}//make error style as priority\n  &&{&:hover.MuiOutlinedInput-root.Mui-error{border-color:var(--color-i-red);}}&.MuiOutlinedInput-root .MuiOutlinedInput-input.Mui-disabled{background:", function(param) {
    var $disabledColor = param.$disabledColor;
    return $disabledColor;
}, ";}");
var TextField = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    var width = props.width, helperText = props.helperText, helperTextColor = props.helperTextColor, enterCallback = props.enterCallback, disabledColor = props.disabledColor, inputProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "width",
        "helperText",
        "helperTextColor",
        "enterCallback",
        "disabledColor"
    ]);
    var onKeyUpWrap = function(e) {
        if (e && e.keyCode === 13) {
            e.preventDefault();
            enterCallback();
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledTextField, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                inputRef: ref,
                variant: "determinate",
                $width: width,
                $disabledColor: disabledColor,
                onKeyUp: enterCallback ? onKeyUpWrap : null
            }, inputProps)),
            helperText && helperText !== "" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledP2, {
                color: helperTextColor,
                children: helperText
            }) : null
        ]
    });
});
TextField.displayName = "TextField";
TextField.propTypes = {
    width: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    helperText: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    helperTextColor: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    enterCallback: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    disabledColor: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};
TextField.defaultProps = {
    width: "",
    helperText: "",
    helperTextColor: "var(--color-i-red)",
    enterCallback: null,
    disabledColor: "var(--color-divider)",
    className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (TextField);


/***/ }),

/***/ 75618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(29815);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _base_H2_H2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39396);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85620);
/* harmony import */ var _comp_Rating_Rating__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48929);
/* harmony import */ var _base_Button_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35415);
/* harmony import */ var _icon_Like__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87643);
/* harmony import */ var _icon_Dislike__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48963);
/* harmony import */ var _base_Drawer_Drawer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15509);
/* harmony import */ var _icon_Liked__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24666);
/* harmony import */ var _icon_Disliked__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76590);
/* harmony import */ var _base_TextField_TextField__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20789);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87936);
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17579);
/* harmony import */ var _hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52405);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2080);
/* harmony import */ var _hooks_useEducatorContext__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(49465);
/* harmony import */ var _api_fetchers_auth__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7056);























var StyH2 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_H2_H2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "e372wqn0",
    label: "StyH2"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_11B */ .t8.qx, ";grid-column:span 10;display:flex;justify-content:center;", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_0B */ .t8.NE, ";}");
var StyP1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "e372wqn1",
    label: "StyP1"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_3B */ .t8.N, ";margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_8B */ .t8.B3, ";grid-column:span 10;text-align:center;", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{margin:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_1B */ .t8.MK, " ", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_0B */ .t8.NE, " ", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_6B */ .t8.BY, ";}");
var Sty2P1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "e372wqn2",
    label: "Sty2P1"
})("margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_5B */ .t8.zj, ";grid-column:span 10;justify-content:center;display:flex;", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_4B */ .t8.BM, ";color:var(--color-text-secondary);}");
var StyledRating = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_comp_Rating_Rating__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "e372wqn3",
    label: "StyledRating"
})("align-items:center;justify-content:center;grid-column:span 10;display:flex;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_12B */ .t8.SL, ";");
var OptionName = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "e372wqn4",
    label: "OptionName"
})("margin-left:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_3B */ .t8.N, ";color:var(--color-text-primary);", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{margin-left:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_0B */ .t8.NE, ";}");
var LikeButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_icon_Like__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "e372wqn5",
    label: "LikeButton"
})("border-width:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .PRIMARY_BORDER_WIDTH */ .UK, ";border-style:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .SOLID_BORDER_STYLE */ .T_, ";border-color:var(--color-divider);padding:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_2B */ .t8.Rw, ";border-radius:50%;cursor:pointer;");
var LikedButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_icon_Liked__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    target: "e372wqn6",
    label: "LikedButton"
})("border-width:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .PRIMARY_BORDER_WIDTH */ .UK, ";border-style:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .SOLID_BORDER_STYLE */ .T_, ";border-color:var(--color-divider);padding:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_2B */ .t8.Rw, ";border-radius:50%;background:", function(param) {
    var $likedDislikedBgColor = param.$likedDislikedBgColor;
    return $likedDislikedBgColor;
}, ";cursor:pointer;");
var DislikeButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_icon_Dislike__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    target: "e372wqn7",
    label: "DislikeButton"
})("margin-left:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_4B */ .t8.BM, ";border-width:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .PRIMARY_BORDER_WIDTH */ .UK, ";border-style:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .SOLID_BORDER_STYLE */ .T_, ";border-color:var(--color-divider);padding:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_2B */ .t8.Rw, ";border-radius:50%;cursor:pointer;");
var DislikedButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_icon_Disliked__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    target: "e372wqn8",
    label: "DislikedButton"
})("margin-left:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_4B */ .t8.BM, ";border-width:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .PRIMARY_BORDER_WIDTH */ .UK, ";border-style:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .SOLID_BORDER_STYLE */ .T_, ";border-color:var(--color-divider);padding:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_2B */ .t8.Rw, ";border-radius:50%;background:", function(param) {
    var $likedDislikedBgColor = param.$likedDislikedBgColor;
    return $likedDislikedBgColor;
}, ";cursor:pointer;");
var Option = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "e372wqn9",
    label: "Option"
})("grid-column:span 10;width:423px;display:flex;justify-content:space-between;align-items:center;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_4B */ .t8.BM, ";padding-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_3B */ .t8.N, ";border-bottom:", function(param) {
    var $showBorder = param.$showBorder;
    return $showBorder && "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_15__/* .PRIMARY_BORDER_WIDTH */ .UK, " ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_15__/* .SOLID_BORDER_STYLE */ .T_, " var(--color-divider)");
}, ";", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;height:56px;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_0B */ .t8.NE, ";padding:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_0B */ .t8.NE, ";}");
var Flex = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "e372wqn10",
    label: "Flex"
})("display:flex;margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_5B */ .t8.zj, ";", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_0B */ .t8.NE, ";}");
var Input = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_TextField_TextField__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
    target: "e372wqn11",
    label: "Input"
})("grid-column:span 10;margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_3B */ .t8.N, ";margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_10B */ .t8.FC, ";color:var(--color-text-primary);", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{margin:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_12B */ .t8.SL, " 0 ", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_4B */ .t8.BM, ";& input{min-height:96px;}}");
var Submit = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_Button_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e372wqn12",
    label: "Submit"
})("align-self:flex-start;", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;grid-column:span 10;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_8B */ .t8.B3, ";}");
var OptionCard = function(param) {
    var option = param.option, showBorder = param.showBorder, select = param.select, deselect = param.deselect, isUpvoted = param.isUpvoted, isDownvoted = param.isDownvoted, likedDislikedBgColor = param.likedDislikedBgColor;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)(Option, {
        $showBorder: showBorder,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(OptionName, {
                children: option.name
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)(Flex, {
                children: [
                    isUpvoted ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(LikedButton, {
                        size: _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_8B */ .t8.B3,
                        onClick: deselect(option),
                        color: "var(--color-base-1)",
                        $likedDislikedBgColor: likedDislikedBgColor
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(LikeButton, {
                        size: _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_8B */ .t8.B3,
                        onClick: select(option, 1),
                        color: "var(--color-text-primary)"
                    }),
                    isDownvoted ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(DislikedButton, {
                        size: _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_8B */ .t8.B3,
                        color: "var(--color-base-1)",
                        onClick: deselect(option),
                        $likedDislikedBgColor: likedDislikedBgColor
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(DislikeButton, {
                        size: _styles_index__WEBPACK_IMPORTED_MODULE_15__/* .Spacings.SPACING_8B */ .t8.B3,
                        onClick: select(option, -1),
                        color: "var(--color-text-primary)"
                    })
                ]
            })
        ]
    });
};
var RateYourExperienceDetails = function(param) {
    var ratingValue = param.ratingValue, setRatingValue = param.setRatingValue, feedBackDetails = param.feedBackDetails, submitFeedback = param.submitFeedback, getFeebackOfAObject = param.getFeebackOfAObject, objectUID = param.objectUID, onClose = param.onClose, drawerState = param.drawerState, source = param.source, goalUID = param.goalUID, entityTitle = param.entityTitle, entityContentType = param.entityContentType, lastPrimarySource = param.lastPrimarySource;
    var ref;
    var isEducatorSide = (0,_hooks_useEducatorContext__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), selectedOptions = ref1[0], setSelectedOption = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), suggestion = ref2[0], setSuggestion = ref2[1];
    var likedDislikedBgColor = "var(--color-base-fill)";
    var goalSegmentData = (0,_hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
        goalUID: goalUID
    });
    var title = feedBackDetails === null || feedBackDetails === void 0 ? void 0 : feedBackDetails.description;
    var handleClick = function(value) {
        return function() {
            return setRatingValue(value);
        };
    };
    var selectedChoice = feedBackDetails === null || feedBackDetails === void 0 ? void 0 : (ref = feedBackDetails.choices) === null || ref === void 0 ? void 0 : ref.filter(function(choice) {
        return choice.description === "".concat(ratingValue);
    })[0];
    var ref3 = selectedChoice || {}, options = ref3.options, selectedChoiceUID = ref3.id;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isSubmittingFeedback = ref4[0], setIsSubmittingFeedback = ref4[1];
    var isUpvoted = function(choice) {
        return !!selectedOptions.find(function(option) {
            return option.id === choice.id && option.value === 1;
        });
    };
    var isDownvoted = function(choice) {
        return !!selectedOptions.find(function(option) {
            return option.id === choice.id && option.value === -1;
        });
    };
    var deselect = function(option) {
        return function() {
            return setSelectedOption(selectedOptions.filter(function(innerOption) {
                return innerOption.id !== option.id;
            }));
        };
    };
    var select = function(option, value) {
        return function() {
            setSelectedOption((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(selectedOptions.filter(function(innerOption) {
                return innerOption.id !== option.id;
            })).concat([
                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, option), {
                    value: value
                })
            ]));
        };
    };
    var sanitizeFeedbackData = function(option) {
        return "review_".concat(option.name.replace(/[^a-zA-Z ]/g, "").replace(/ +(?= )/g, "").split(" ").map(function(word) {
            return word.toLowerCase();
        }).join("_"));
    };
    var getSegmentDataForPlusHomeFeedback = function() {
        var selectedFeedBack = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var segData = {};
        options.forEach(function(option) {
            var name = sanitizeFeedbackData(option);
            segData[name] = null;
        });
        selectedFeedBack.forEach(function(option) {
            var name = sanitizeFeedbackData(option);
            segData[name] = option.value;
        });
        segData.plus_experience_rating = ratingValue;
        return segData;
    };
    var handleSubmit = function() {
        setIsSubmittingFeedback(true);
        submitFeedback({
            others: suggestion,
            options: selectedOptions,
            choice_id: selectedChoiceUID,
            object_id: objectUID
        }, feedBackDetails === null || feedBackDetails === void 0 ? void 0 : feedBackDetails.uid).then(function(response) {
            setIsSubmittingFeedback(false);
            if (source === _constants_segment__WEBPACK_IMPORTED_MODULE_13__/* .PLUS_HOME_FEEDBACK_SUBMITTED */ .Omu || source === _constants_segment__WEBPACK_IMPORTED_MODULE_13__/* .SUBSCRIPTION_FEEDBACK_CARD_SUBMITTED */ .sHI) {
                var segmentData = getSegmentDataForPlusHomeFeedback(selectedOptions);
                var updateSegmentData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, segmentData, goalSegmentData);
                if (source === _constants_segment__WEBPACK_IMPORTED_MODULE_13__/* .SUBSCRIPTION_FEEDBACK_CARD_SUBMITTED */ .sHI) {
                    updateSegmentData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, updateSegmentData), {
                        entity_uid: objectUID,
                        entity_title: entityTitle,
                        entity_content_type: entityContentType,
                        last_primary_source: lastPrimarySource
                    });
                }
                _actions_analytics__WEBPACK_IMPORTED_MODULE_12__/* .segment.track */ .EX.track(source, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, updateSegmentData));
            }
            if (source === _constants_segment__WEBPACK_IMPORTED_MODULE_13__/* .GTP_SUBSCRIPTION_FEEDBACK_CARD_SUBMITTED */ .eQs) {
                (0,_api_fetchers_auth__WEBPACK_IMPORTED_MODULE_17__/* .fetchSubscriptionFeedbackCards */ .Wf)(goalUID);
            }
            if (response.result) {
                if (getFeebackOfAObject) getFeebackOfAObject(objectUID);
                onClose({
                    hasSubmittedFeedback: true
                });
                setSuggestion("");
                setSelectedOption([]);
            }
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsxs */ .BX)(_base_Drawer_Drawer__WEBPACK_IMPORTED_MODULE_8__["default"], {
        drawerState: drawerState,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(StyH2, {
                color: "var(--color-text-primary)",
                children: "Rate your experience"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(StyP1, {
                color: "var(--color-text-primary)",
                children: title || "How is your learning experience?"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(StyledRating, {
                value: ratingValue,
                setRating: handleClick,
                starColor: "var(--color-i-orange-1)"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(Sty2P1, {
                color: "var(--color-text-primary)",
                children: "How satisfied are you with"
            }),
            options === null || options === void 0 ? void 0 : options.map(function(option, index) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(OptionCard, {
                    option: option,
                    showBorder: index + 1 !== options.length,
                    select: select,
                    deselect: deselect,
                    isUpvoted: isUpvoted(option),
                    isDownvoted: isDownvoted(option),
                    likedDislikedBgColor: likedDislikedBgColor
                }, option.id);
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(Input, {
                placeholder: "Tell us more about your experience",
                value: suggestion,
                onChange: function(e) {
                    return setSuggestion(e.target.value);
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__/* .jsx */ .tZ)(Submit, {
                label: "Submit",
                onClick: handleSubmit,
                variant: isSubmittingFeedback ? "disabled" : "filled",
                color: isEducatorSide ? "blue" : "green"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RateYourExperienceDetails);
RateYourExperienceDetails.propTypes = {
    ratingValue: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().number.isRequired),
    setRatingValue: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().func.isRequired),
    feedBackDetails: prop_types__WEBPACK_IMPORTED_MODULE_22___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_22___default().any)).isRequired,
    submitFeedback: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().func.isRequired),
    getFeebackOfAObject: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().func),
    objectUID: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().string.isRequired),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().func.isRequired),
    drawerState: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().bool.isRequired),
    source: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().string),
    goalUID: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().string),
    entityTitle: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().string),
    entityContentType: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().string),
    lastPrimarySource: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().string)
};
RateYourExperienceDetails.defaultProps = {
    getFeebackOfAObject: null,
    source: null,
    goalUID: null,
    entityTitle: "",
    entityContentType: "",
    lastPrimarySource: ""
};
OptionCard.propTypes = {
    option: prop_types__WEBPACK_IMPORTED_MODULE_22___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_22___default().any)).isRequired,
    showBorder: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().bool.isRequired),
    select: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().func.isRequired),
    deselect: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().func.isRequired),
    isUpvoted: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().bool.isRequired),
    isDownvoted: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().bool.isRequired),
    likedDislikedBgColor: (prop_types__WEBPACK_IMPORTED_MODULE_22___default().string)
};
OptionCard.defaultProps = {
    likedDislikedBgColor: "var(--color-base-fill)"
};


/***/ }),

/***/ 48929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _icon_StarFilled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52885);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2080);






var Star = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_icon_StarFilled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "ep37bpj0",
    label: "Star"
})("margin-left:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";cursor:", function(param) {
    var isReadOnly = param.isReadOnly;
    return isReadOnly ? "auto" : "pointer";
}, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.mobile */ .AV.mobile, "){width:32px;height:32px;:first-child{margin-left:0;}}");
var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ep37bpj1",
    label: "Wrapper"
})("display:flex;");
var Rating = function(param) {
    var maxRating = param.maxRating, setRating = param.setRating, value = param.value, className = param.className, isReadOnly = param.isReadOnly, starColor = param.starColor;
    var data = value + 1;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(data), starNumber = ref[0], setStarNumber = ref[1];
    var handleMouseLeave = function() {
        if (isReadOnly) return;
        setStarNumber(data);
    };
    var handleMouseEnter = function(index) {
        return function() {
            if (isReadOnly) return;
            setStarNumber(index + 2);
        };
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, {
        onMouseLeave: handleMouseLeave,
        className: className,
        children: Array.from({
            length: maxRating
        }, function(v, k) {
            return k + 1;
        }).map(function(rating, index) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                onMouseEnter: handleMouseEnter(index),
                onMouseLeave: handleMouseLeave,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Star, {
                    isReadOnly: isReadOnly,
                    color: rating < starNumber ? starColor || "var(--color-i-orange-1)" : "var(--color-divider)",
                    size: _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_8B */ .t8.B3,
                    onClick: setRating(rating)
                }, rating)
            }, rating);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Rating);
Rating.propTypes = {
    maxRating: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    setRating: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    isReadOnly: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    starColor: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
Rating.defaultProps = {
    maxRating: 5,
    setRating: function() {},
    className: "",
    isReadOnly: false,
    starColor: "var(--color-i-orange-1)"
};


/***/ }),

/***/ 98342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ postPopupViewed; },
/* harmony export */   "t": function() { return /* binding */ activateFreeTrial; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _api_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19982);



var postPopupViewed = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(goalUID) {
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,_api_fetchers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("v1/user/DO4H1VZTYK/trial/expiry-pop-up/", {
                        requestType: "post",
                        body: {
                            goal_uid: goalUID
                        }
                    });
                case 3:
                    _ctx.next = 7;
                    break;
                case 5:
                    _ctx.prev = 5;
                    _ctx.t0 = _ctx["catch"](0);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                5
            ]
        ]);
    }));
    return function postPopupViewed(goalUID) {
        return _ref.apply(this, arguments);
    };
}();
var activateFreeTrial = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(goalUID) {
        var data;
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,_api_fetchers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("v2/subscriptions/trial/grant/", {
                        requestType: "post",
                        body: {
                            goal: goalUID,
                            referral_code: "FTWEB10"
                        }
                    });
                case 3:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function activateFreeTrial(goalUID) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 96521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P9": function() { return /* binding */ setActivateButtonClicked; }
/* harmony export */ });
/* unused harmony export freeTrialStore */
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);


var freeTrialStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return {
        buttonClicked: false,
        setButtonClicked: function(isClicked) {
            return set(function() {
                return {
                    buttonClicked: isClicked
                };
            });
        }
    };
});
var setActivateButtonClicked = function(isClicked) {
    return freeTrialStore.getState().setButtonClicked(isClicked);
};
var useFreeTrialStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(freeTrialStore);
/* harmony default export */ __webpack_exports__["ZP"] = (useFreeTrialStore);


/***/ }),

/***/ 976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87936);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73060);
/* harmony import */ var _api_selectors_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58063);
/* harmony import */ var _constants_toggleables__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28119);
/* harmony import */ var _hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52405);
/* harmony import */ var _stores_toggleables__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85690);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98342);
/* harmony import */ var _freeTrialStore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96521);












var useFreeTrial = function(goalUID) {
    var isLoggedIn = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_8__/* .getIsLoggedIn */ .M7);
    var isClicked = (0,_freeTrialStore__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(state) {
        return state.buttonClicked;
    });
    var ref = (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_4__/* .useToggleable */ .F7)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_9__/* .LOGIN_DRAWER */ .es), openLoginDrawer = ref.openElement;
    var subscriptions = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_api_selectors_subscription__WEBPACK_IMPORTED_MODULE_2__/* .getMeLatestUserSubscriptionsForGoal */ .A_)(goalUID));
    var refetchMyInfo = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().refetchMyInfo;
    var goalEventsProps = (0,_hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        goalUID: goalUID
    });
    var freeTrialSubscription = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        return subscriptions.find(function(subscription) {
            return subscription.subscription.type === 2;
        });
    }, [
        subscriptions
    ]);
    var hadFreeTrialSubscription = (freeTrialSubscription === null || freeTrialSubscription === void 0 ? void 0 : freeTrialSubscription.timeRemaining) <= 0;
    var hasFreeTrialSubscription = (freeTrialSubscription === null || freeTrialSubscription === void 0 ? void 0 : freeTrialSubscription.timeRemaining) > 0;
    var hadSubscription = subscriptions.find(function(subscription) {
        return subscription.timeRemaining === 0;
    });
    var handleAnalytics = function() {
        _actions_analytics__WEBPACK_IMPORTED_MODULE_0__/* .segment.track */ .EX.track("Free Trial - Free Trial Activated", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, goalEventsProps), {
            last_primary_source: "Goal Home",
            last_primary_source_section: "Free Trial Section"
        }));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (isLoggedIn && isClicked && subscriptions.length === 0) {
            // hit api
            (0,_api__WEBPACK_IMPORTED_MODULE_6__/* .activateFreeTrial */ .t)(goalUID).then(function(res) {
                var ref;
                if (res === null || res === void 0 ? void 0 : (ref = res.error) === null || ref === void 0 ? void 0 : ref.errorCode) return;
                handleAnalytics();
                refetchMyInfo();
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoggedIn
    ]);
    var onClick = function() {
        (0,_freeTrialStore__WEBPACK_IMPORTED_MODULE_7__/* .setActivateButtonClicked */ .P9)(true);
        if (!isLoggedIn) {
            openLoginDrawer();
        } else {
            // hit api
            (0,_api__WEBPACK_IMPORTED_MODULE_6__/* .activateFreeTrial */ .t)(goalUID).then(function(res) {
                var ref;
                if (res === null || res === void 0 ? void 0 : (ref = res.error) === null || ref === void 0 ? void 0 : ref.errorCode) return;
                handleAnalytics();
                refetchMyInfo();
            });
        }
    };
    return {
        onClick: onClick,
        hadFreeTrialSubscription: hadFreeTrialSubscription,
        hasFreeTrialSubscription: hasFreeTrialSubscription,
        hadSubscription: hadSubscription,
        freeTrialSubscription: freeTrialSubscription || {}
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useFreeTrial);


/***/ }),

/***/ 92490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SubscriptionRatingStar; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/Icons/Icon.jsx
var Icon = __webpack_require__(55447);
;// CONCATENATED MODULE: ./src/components/Icons/Planner/SubscriptionStar.jsx




var StarFilled = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 26 24"
    }, props), {
        path: "M10.9816 1.48551C11.8808 -0.0641819 14.1187 -0.0641776 15.018 1.48551L17.7718 6.23132C18.0256 6.66877 18.4643 6.96729 18.9644 7.04282L23.5373 7.7335C25.5306 8.03456 26.2298 10.5513 24.6774 11.8375L21.3456 14.5979C20.8779 14.9853 20.658 15.5965 20.7716 16.1931L21.7049 21.0944C22.0705 23.0143 20.055 24.506 18.3257 23.5954L13.7763 21.2C13.2902 20.9441 12.7093 20.9441 12.2233 21.2L7.67389 23.5954C5.94454 24.506 3.92904 23.0143 4.29464 21.0944L5.22795 16.1931C5.34155 15.5965 5.12166 14.9853 4.654 14.5979L1.32213 11.8375C-0.230249 10.5513 0.468955 8.03456 2.46228 7.7335L7.03514 7.04282C7.53523 6.96729 7.97396 6.66877 8.22779 6.23132L10.9816 1.48551ZM13.2881 2.48928C13.1596 2.2679 12.8399 2.2679 12.7115 2.48928L9.95766 7.23509C9.39923 8.19747 8.43402 8.85422 7.33383 9.02039L2.76097 9.71107C2.47621 9.75408 2.37632 10.1136 2.59809 10.2973L5.92996 13.0578C6.9588 13.9102 7.44257 15.2547 7.19264 16.5672L6.25933 21.4685C6.20711 21.7427 6.49503 21.9559 6.74209 21.8258L11.2915 19.4303C12.3608 18.8673 13.6388 18.8673 14.7081 19.4303L19.2575 21.8258C19.5045 21.9559 19.7924 21.7428 19.7402 21.4685L18.8069 16.5672C18.557 15.2547 19.0407 13.9102 20.0696 13.0578L23.4015 10.2973C23.6232 10.1136 23.5233 9.75408 23.2386 9.71107L18.6657 9.02039C17.5655 8.85422 16.6003 8.19747 16.0419 7.2351L13.2881 2.48928Z"
    }));
};
/* harmony default export */ var SubscriptionStar = (StarFilled);

;// CONCATENATED MODULE: ./src/components/Icons/Planner/FilledSubscriptionStar.jsx




var FilledSubscriptionStar_StarFilled = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 26 24"
    }, props), {
        path: "M15.0174 1.48209C14.1185 -0.0675955 11.8814 -0.0675998 10.9826 1.48209L8.22979 6.2279C7.97604 6.66535 7.53748 6.96387 7.03758 7.0394L2.46643 7.73008C0.473838 8.03115 -0.225104 10.5479 1.3267 11.834L4.65732 14.5945C5.12481 14.9819 5.34462 15.5931 5.23106 16.1896L4.29809 21.0909C3.93264 23.0109 5.94738 24.5026 7.67609 23.592L12.2238 21.1966C12.7096 20.9407 13.2903 20.9407 13.7762 21.1966L18.3239 23.592C20.0526 24.5026 22.0673 23.0109 21.7019 21.0909L20.7689 16.1896C20.6554 15.5931 20.8752 14.9819 21.3426 14.5945L24.6733 11.834C26.2251 10.5479 25.5261 8.03115 23.5335 7.73008L18.9624 7.0394C18.4625 6.96387 18.0239 6.66535 17.7702 6.22791L15.0174 1.48209Z"
    }));
};
/* harmony default export */ var FilledSubscriptionStar = (FilledSubscriptionStar_StarFilled);

// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
;// CONCATENATED MODULE: ./src/components/Container/Planner/PlannerCards/SubscriptionFeedbackCard/SubscriptionRatingStar.jsx







var StarContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1ag8sm40",
    label: "StarContainer"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";cursor:pointer;");
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1ag8sm41",
    label: "Wrapper"
})("display:flex;");
var SubscriptionRatingStars = function(param) {
    var maxRating = param.maxRating, setRating = param.setRating, value = param.value, className = param.className;
    var data = value + 1;
    var ref = (0,react.useState)(data), starNumber = ref[0], setStarNumber = ref[1];
    (0,react.useEffect)(function() {
        setStarNumber(data);
    }, [
        data
    ]);
    var handleMouseLeave = function() {
        return setStarNumber(data);
    };
    var handleMouseEnter = function(index) {
        return function() {
            return setStarNumber(index + 2);
        };
    };
    var handleClick = function(ratingValue) {
        return function() {
            setRating(ratingValue)();
            setStarNumber(data);
        };
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        onMouseLeave: handleMouseLeave,
        className: className,
        children: Array.from({
            length: maxRating
        }, function(v, k) {
            return k + 1;
        }).map(function(rating, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StarContainer, {
                onMouseEnter: handleMouseEnter(index),
                onMouseLeave: handleMouseLeave,
                children: [
                    rating >= starNumber && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscriptionStar, {
                        color: "var(--color-i-brown-3)",
                        size: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                        onClick: handleClick(rating)
                    }, rating),
                    rating < starNumber && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FilledSubscriptionStar, {
                        color: "var(--color-i-brown-3)",
                        size: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                        onClick: handleClick(rating)
                    }, rating)
                ]
            }, rating);
        })
    });
};
SubscriptionRatingStars.propTypes = {
    maxRating: (prop_types_default()).number,
    setRating: (prop_types_default()).func,
    value: (prop_types_default()).number.isRequired,
    className: (prop_types_default()).string
};
SubscriptionRatingStars.defaultProps = {
    maxRating: 5,
    setRating: function() {},
    className: ""
};
/* harmony default export */ var SubscriptionRatingStar = (SubscriptionRatingStars);


/***/ }),

/***/ 88322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ DAILY_GOALS_OPTIONS; },
/* harmony export */   "Fj": function() { return /* binding */ DPP_SET_REMINDER_CLICKED; },
/* harmony export */   "G8": function() { return /* binding */ TOOLTIP_MAP; },
/* harmony export */   "Jb": function() { return /* binding */ DPP_COMPLETED; },
/* harmony export */   "Jf": function() { return /* binding */ QUERY_ACTIONS; },
/* harmony export */   "Kd": function() { return /* binding */ MAX_PRACTICE_SESSION_COUNT; },
/* harmony export */   "LJ": function() { return /* binding */ DISLIKE_REASONS; },
/* harmony export */   "Lr": function() { return /* binding */ MIN_QUESTIONS; },
/* harmony export */   "MA": function() { return /* binding */ FEEDBACK_OPTIONS_MAPPING; },
/* harmony export */   "Ny": function() { return /* binding */ MODAL_TYPES; },
/* harmony export */   "R1": function() { return /* binding */ DPP_SET_REMINDER_CARD_VIEWED; },
/* harmony export */   "Sx": function() { return /* binding */ YEAR_FILTER_TYPE; },
/* harmony export */   "Up": function() { return /* binding */ noPrefrenceCode; },
/* harmony export */   "VL": function() { return /* binding */ REVIEW_TYPE; },
/* harmony export */   "Ws": function() { return /* binding */ PRACTICE_TYPE; },
/* harmony export */   "Xg": function() { return /* binding */ TIME_LAPSE_LIMIT; },
/* harmony export */   "Y8": function() { return /* binding */ practiceActionTypes; },
/* harmony export */   "ad": function() { return /* binding */ LANGUAGE; },
/* harmony export */   "cq": function() { return /* binding */ PRACTICE_MIN_QUESTION_NUM; },
/* harmony export */   "gi": function() { return /* binding */ DEFAULT_LANGUAGE_INFO; },
/* harmony export */   "jb": function() { return /* binding */ DEFAULT_DAILY_GOAL; },
/* harmony export */   "ki": function() { return /* binding */ SUBJECTS; },
/* harmony export */   "lz": function() { return /* binding */ DAILY_REMINDER_OPTIONS; },
/* harmony export */   "nI": function() { return /* binding */ PRACTICE_FLOW_TYPE; },
/* harmony export */   "oH": function() { return /* binding */ DPP_INCOMPLETE; },
/* harmony export */   "oZ": function() { return /* binding */ SKIP_REASONS; },
/* harmony export */   "pj": function() { return /* binding */ DEFAULT_TIME; },
/* harmony export */   "qu": function() { return /* binding */ DEFAULT_TIME_IN_TEXT; },
/* harmony export */   "xl": function() { return /* binding */ MAX_QUESTIONS; }
/* harmony export */ });
/* unused harmony exports getHoursOptions, getRoundedGTPPracticeQuestionCount, DPP_PREFERENCES_QUESTION, PRACTICE_SETTINGS_CLICKED */
/* harmony import */ var _constants_practice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11238);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97428);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48821);



var noPrefrenceCode = -1;
var LANGUAGE = {
    ALL: {
        display_name: "All",
        code: 0
    }
};
var DEFAULT_LANGUAGE_INFO = {
    user_preference: 0,
    available_languages: [],
    language_selection_available: false
};
var PRACTICE_TYPE = {
    FULL: 1,
    EACH_TOPIC: 2,
    PYQ: 3,
    TEXTBOOK: 4,
    INCORRECT: 5
};
var PRACTICE_FLOW_TYPE = {
    NORMAL_PRACTICE: "1",
    CLASS_PRACTICE: "2",
    SYLLABUS_PRACTICE: "3",
    AUTO_DPP: "4"
};
var DISLIKE_REASONS = [
    "Mistake in the question/option choices",
    "Mistake in solution",
    "Technical issue",
    "Plagiarism"
];
var YEAR_FILTER_TYPE = {
    ALL: "all-filter"
};
var SKIP_REASONS = [
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.DIFFICULT_QUESTION */ .X.DIFFICULT_QUESTION,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/thinking-face.svg")
    },
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.DIDNT_UNDERSTAND */ .X.DIDNT_UNDERSTAND,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/confused.svg")
    },
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.HAVENT_STUDIED */ .X.HAVENT_STUDIED,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/exclamation-question.svg")
    }
];
var REVIEW_TYPE = {
    POSITIVE: 1,
    NEGATIVE: 2
};
var SUBJECTS = {
    ALL: -1
};
var MAX_QUESTIONS = 30;
var MIN_QUESTIONS = 5;
var FEEDBACK_OPTIONS_MAPPING = {
    POSITIVE: {
        QUALITY_OF_SOLUTIONS: 496,
        QUALITY_OF_QUESTIONS: 497,
        MIX_OF_QUESTIONS: 498,
        INTERFACE: 499,
        SYLLABUS: 500
    },
    NEGATIVE: {
        QUALITY_OF_SOLUTIONS: 501,
        QUALITY_OF_QUESTIONS: 502,
        MIX_OF_QUESTIONS: 503,
        INTERFACE: 504,
        SYLLABUS: 505
    }
};
var DAILY_GOALS_OPTIONS = [
    {
        value: 10,
        label: "10 questions"
    },
    {
        value: 20,
        label: "20 questions"
    },
    {
        value: 30,
        label: "30 questions"
    }
];
var getHoursOptions = function() {
    var options = [];
    var ref = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .generateHours */ .SA)({
        interval: 30
    }), twentyFourHrFormat = ref.twentyFourHrFormat, twelveHrFormat = ref.twelveHrFormat;
    twelveHrFormat.forEach(function(hour, index) {
        options.push({
            value: twentyFourHrFormat[index],
            label: hour
        });
    });
    return options;
};
var DAILY_REMINDER_OPTIONS = getHoursOptions();
var MODAL_TYPES = {
    PRACTICE_REMINDER: "PRACTICE_REMINDER"
};
var QUERY_ACTIONS = {
    SHOW_REMINDER_SETTING: "show_reminder_setting"
};
var TOOLTIP_MAP = {
    TOTAL_QUESTION_LIMIT_REACHED: "Total questions limit reached",
    CANNOT_ADD_MORE_QUESTIONS: "Cannot add more questions",
    NULL: ""
};
var PRACTICE_MIN_QUESTION_NUM = 5;
var getRoundedGTPPracticeQuestionCount = function(count) {
    return Math.floor(count / 100) * 100;
};
var practiceActionTypes = {
    SET_REMINDER_DEFAULT_DATA: "SET_REMINDER_DEFAULT_DATA"
};
var MAX_PRACTICE_SESSION_COUNT = 5;
var TIME_LAPSE_LIMIT = 7;
var DEFAULT_DAILY_GOAL = 10;
var DEFAULT_TIME = "09:00";
var DEFAULT_TIME_IN_TEXT = "09:00 AM";
var DPP_SET_REMINDER_CARD_VIEWED = "DPP - Set Reminder Card Viewed ";
var DPP_SET_REMINDER_CLICKED = "DPP - Set Reminder Clicked";
var DPP_PREFERENCES_QUESTION = "DPP - Preferences Question";
var PRACTICE_SETTINGS_CLICKED = "Practice - Settings Clicked";
var DPP_COMPLETED = 1;
var DPP_INCOMPLETE = 0;


/***/ }),

/***/ 48963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Dislike = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M70 10.2c1.381 0 2.5 1.119 2.5 2.5v0 36.4c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5v0-36.4c0-1.381 1.119-2.5 2.5-2.5v0z M24.467 9.467h26.1c4.57 0.019 8.267 3.728 8.267 8.3 0 0 0 0 0 0v0 28.9c0 0.018 0 0.039 0 0.060 0 2.279-0.945 4.337-2.465 5.804l-0.002 0.002-15.9 15.933c-1.215 1.264-2.92 2.050-4.809 2.050-1.333 0-2.575-0.391-3.617-1.066l0.026 0.016c-1.351-0.799-2.387-2.008-2.951-3.453l-0.016-0.047c-0.224-0.666-0.358-1.432-0.367-2.229v-1.171l2.167-10.5h-15.1c-4.576-0.019-8.281-3.724-8.3-8.298v-5.735c0.008-1.092 0.215-2.134 0.587-3.093l-0.020 0.060 8.8-20.5c1.282-2.983 4.194-5.033 7.586-5.033 0.005 0 0.010 0 0.015 0h-0.001zM35.7 65.5c0.009 0 0.019 0 0.029 0 0.471 0 0.897-0.191 1.204-0.5l0-0 15.933-15.967c0.596-0.571 0.967-1.374 0.967-2.264 0-0.013-0-0.026-0-0.038v0.002-28.967c0-1.841-1.492-3.333-3.333-3.333v0h-26.033c-1.337 0.023-2.48 0.829-2.992 1.979l-0.008 0.021-8.767 20.467c-0.127 0.325-0.2 0.702-0.2 1.096 0 0.013 0 0.026 0 0.039v-0.002 5.8c0 1.841 1.492 3.333 3.333 3.333v0h18.267c0.004 0 0.008 0 0.012 0 0.77 0 1.459 0.348 1.918 0.896l0.003 0.004c0.4 0.446 0.645 1.039 0.645 1.689 0 0.086-0.004 0.171-0.013 0.255l0.001-0.011-2.8 13.9s0 0 0 0.367c0.137 0.325 0.368 0.589 0.659 0.763l0.007 0.004c0.323 0.249 0.722 0.417 1.156 0.466l0.011 0.001z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Dislike);


/***/ }),

/***/ 76590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Disliked = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M72.5 10.2c0.663 0 1.299 0.263 1.768 0.732s0.732 1.105 0.732 1.768v36.4c0 0.663-0.263 1.299-0.732 1.768s-1.105 0.732-1.768 0.732c-0.663 0-1.299-0.263-1.768-0.732s-0.732-1.105-0.732-1.768v-36.4c0-0.663 0.263-1.299 0.732-1.768s1.105-0.732 1.768-0.732z M18.304 52.134h15.2l-2.166 10.5v1.167c0.008 0.759 0.131 1.512 0.366 2.233 0.561 1.471 1.608 2.706 2.966 3.5 1.3 0.831 2.847 1.185 4.379 1.003s2.953-0.89 4.021-2.003l15.8-15.933c0.796-0.767 1.425-1.69 1.85-2.71s0.634-2.118 0.617-3.223v-28.967c0-2.195-0.87-4.301-2.419-5.857s-3.652-2.434-5.847-2.443h-26.1c-1.621-0.003-3.208 0.474-4.56 1.369s-2.41 2.17-3.040 3.665l-8.8 20.5c-0.367 0.969-0.559 1.997-0.566 3.033v5.867c0.009 2.199 0.886 4.305 2.441 5.859s3.66 2.432 5.859 2.441z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Disliked);


/***/ }),

/***/ 87643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Like = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M10 69.8c-1.381 0-2.5-1.119-2.5-2.5v0-36.4c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5v0 36.4c0 1.381-1.119 2.5-2.5 2.5v0zM55.533 70.533h-26.1c-4.57-0.019-8.267-3.728-8.267-8.3 0 0 0-0 0-0v0-28.9c-0-0.018-0-0.039-0-0.060 0-2.279 0.945-4.337 2.465-5.804l0.002-0.002 15.9-15.933c1.215-1.264 2.92-2.050 4.809-2.050 1.333 0 2.575 0.391 3.617 1.066l-0.026-0.016c1.351 0.799 2.387 2.008 2.951 3.453l0.016 0.047c0.224 0.666 0.358 1.432 0.367 2.229v1.171l-2.267 10.433h15.2c4.576 0.019 8.281 3.724 8.3 8.298v5.802c-0.008 1.092-0.215 2.134-0.587 3.093l0.020-0.060-8.8 20.5c-1.282 2.983-4.194 5.033-7.586 5.033-0.005 0-0.010 0-0.015 0h0.001zM44.3 14.5c-0.009-0-0.019-0-0.029-0-0.471 0-0.897 0.191-1.204 0.5l-0 0-15.933 15.967c-0.596 0.571-0.967 1.374-0.967 2.264 0 0.013 0 0.026 0 0.038v-0.002 28.967c0 1.841 1.492 3.333 3.333 3.333v0h26.1c1.337-0.023 2.48-0.829 2.992-1.979l0.008-0.021 8.767-20.433c0.127-0.325 0.2-0.702 0.2-1.096 0-0.013-0-0.026-0-0.039v0.002-5.833c0-1.841-1.492-3.333-3.333-3.333v0h-18.3c-0.004 0-0.008 0-0.012 0-0.77 0-1.459-0.348-1.918-0.896l-0.003-0.004c-0.419-0.451-0.675-1.056-0.675-1.722 0-0.074 0.003-0.148 0.009-0.221l-0.001 0.009 2.8-13.9v-0.367c-0.137-0.325-0.368-0.589-0.659-0.763l-0.007-0.004c-0.323-0.249-0.722-0.417-1.156-0.466l-0.011-0.001z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Like);


/***/ }),

/***/ 24666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Liked = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M12.5 69.8c-0.663 0-1.299-0.263-1.768-0.732s-0.732-1.105-0.732-1.768v-36.4c0-0.663 0.263-1.299 0.732-1.768s1.105-0.732 1.768-0.732c0.663 0 1.299 0.263 1.768 0.732s0.732 1.105 0.732 1.768v36.4c0 0.663-0.263 1.299-0.732 1.768s-1.105 0.732-1.768 0.732z M66.696 27.866h-15.2l2.166-10.5v-1.167c-0.008-0.759-0.131-1.512-0.366-2.233-0.561-1.471-1.608-2.706-2.966-3.5-1.3-0.831-2.847-1.185-4.379-1.003s-2.953 0.89-4.021 2.003l-15.8 15.933c-0.796 0.767-1.425 1.69-1.85 2.71s-0.634 2.118-0.617 3.223v28.967c0 2.195 0.87 4.301 2.419 5.858s3.652 2.434 5.847 2.442h26.1c1.621 0.003 3.208-0.474 4.56-1.369s2.41-2.17 3.040-3.665l8.8-20.5c0.367-0.969 0.559-1.997 0.566-3.033v-5.867c-0.009-2.199-0.886-4.305-2.441-5.859s-3.66-2.432-5.859-2.441z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Liked);


/***/ }),

/***/ 11238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SKIP_REASONS_MAP; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var SKIP_REASONS_MAP = {
    DIFFICULT_QUESTION: "Difficult Question",
    DIDNT_UNDERSTAND: "Didn't Understand",
    HAVENT_STUDIED: "Haven't studied"
};


/***/ }),

/***/ 34482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ getTopicLinkHref; },
/* harmony export */   "EN": function() { return /* binding */ getSpecialClassesLinkHref; },
/* harmony export */   "Ho": function() { return /* binding */ getHrefAndAsOfAFreeCourse; },
/* harmony export */   "Hw": function() { return /* binding */ getLinkHref; },
/* harmony export */   "Lb": function() { return /* binding */ getSpecialClassesLink; },
/* harmony export */   "Po": function() { return /* binding */ getSpecialClassesAllLink; },
/* harmony export */   "Rg": function() { return /* binding */ getLink; },
/* harmony export */   "TW": function() { return /* binding */ getCoursesHref; },
/* harmony export */   "UP": function() { return /* binding */ getBrowseLink; },
/* harmony export */   "_Y": function() { return /* binding */ getYoutubeLessonLink; },
/* harmony export */   "b4": function() { return /* binding */ getCoursesAsPath; },
/* harmony export */   "bU": function() { return /* binding */ getYoutubeCourseLink; },
/* harmony export */   "bc": function() { return /* binding */ getLinkPath; },
/* harmony export */   "dF": function() { return /* binding */ getTopicListLink; },
/* harmony export */   "dL": function() { return /* binding */ getEntityData; },
/* harmony export */   "pA": function() { return /* binding */ getTopicLink; },
/* harmony export */   "s3": function() { return /* binding */ getTopicListHref; },
/* harmony export */   "v9": function() { return /* binding */ getGtpFreeClassesAllLink; },
/* harmony export */   "vX": function() { return /* binding */ getHrefAndAsOfSaved; },
/* harmony export */   "vx": function() { return /* binding */ getPannerLink; },
/* harmony export */   "yb": function() { return /* binding */ getTopologyName; }
/* harmony export */ });
/* unused harmony exports topologyModal, getBrowseLinkAs, getBrowseLinkHref, getPlannerLinkAs, plannerLink */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43135);



function topologyModal(topology) {
    var ref;
    // window map
    // "today": 0,
    // "tomorrow": 1,
    // "this week": 2,
    // "in 15 days": 3,
    // "yesterday": -1,
    // "last week": -2,
    // "15 days ago": -3,
    return {
        uid: topology.uid,
        name: topology.name,
        permalink: topology.permalink,
        relativeLink: topology.relative_link,
        goalSlug: topology.slug,
        title: topology.title,
        coursesCount: topology.courses_count || topology.item_count || topology.count || topology.plus_course_count || topology.course_count || 0,
        upcomingCoursesCount: topology.upcoming_count || 0,
        upcomingCoursesThisMonth: topology.upcoming_this_month || 0,
        enrolledCoursesCount: topology.enrolled_count || 0,
        totalSubItem: topology.total_subItem || 0,
        progress: topology.progress || 0,
        color: topology.color,
        plusCourseCount: topology.plusCourseCount || topology.total_count || 0,
        colorCode: topology.color_code,
        level: topology.level,
        fullName: topology.title,
        icon: topology.icon,
        children: topology.children,
        slug: topology.slug || (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .getStringWordsJoinedWith */ .kL)(topology.name, "-"),
        parent: topology.parent,
        isPracticeAvailable: topology.is_practice_session,
        isPlusAvailable: topology.is_plus_available,
        isFreeUnavailable: topology.is_free_unavailable,
        language: topology.language || null,
        ogImage: topology.og_image || null,
        window: topology.window,
        windowCount: topology.window_count,
        selfDataFetched: topology.selfDataFetched || false,
        tags: topology.tags,
        isNoTestGoal: !!((ref = topology.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return (tag === null || tag === void 0 ? void 0 : tag.name) === "NON_TEST_PREP";
        })),
        isIconicAvailable: topology.is_iconic_available,
        externalApps: topology.external_apps_available,
        isSyllabusV1Enabled: topology.is_syllabus_v1_enabled,
        isPlatformGoal: topology.is_platform_goal || false,
        goalLevelOnboarding: {
            isAvailable: topology.is_goal_onboarding_available || false,
            status: topology.user_onboarding_status || null,
            hideNudge: false
        },
        isLeaderdboardMetaInfoAvailable: topology.is_leaderdboard_meta_info_available,
        leaderboardFilters: topology.leaderboard_filters,
        leaderboardScreenMetaInfo: topology.leaderboard_screen_meta_info,
        isCatalogueFeatureAvailable: topology.is_catalogue_feature_available || false,
        isK12: topology.is_k12_goal || false,
        isUaIconGoal: topology.is_ua_icon_goal || false,
        isRecordedGoal: topology.is_recorded_goal,
        isCentreAvailable: topology.is_centre_available
    };
}
function getEntityData(data) {
    return topologyModal(data);
}
var getLink = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid);
};
var getBrowseLinkAs = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid, "/browse");
};
var getBrowseLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]/browse";
};
var getBrowseLink = function(data) {
    return {
        as: getBrowseLinkAs(data),
        href: getBrowseLinkHref()
    };
};
var getPlannerLinkAs = function(data) {
    return "/goal/".concat(data.slug, "/").concat(data.uid, "/planner");
};
var plannerLink = "/goal/[goalSlug]/[goalUID]/planner";
var getPannerLink = function(data) {
    return {
        as: getPlannerLinkAs(data),
        href: plannerLink
    };
};
/**
 * Retuns link href of a generic goal
 * @returns string pattern of a generic goal href
 */ var getLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]";
};
var getTopicLink = function(topic, goal) {
    return "/goal/".concat(goal.slug, "/").concat(goal.uid, "/topic/").concat(topic.uid);
};
var getTopicLinkHref = function() {
    return "/goal/[goalSlug]/[goalUID]/topic/[topicUid]";
};
var getTopicListLink = function(goal) {
    return "/goal/".concat(goal.slug, "/").concat(goal.uid, "/topics");
};
var getTopicListHref = function() {
    return "/goal/goalSlug/goalUID/topics";
};
var getLinkPath = function() {
    return "/goal/[goalSlug]/[goalUID]/topic/[topicUid]";
};
var getSpecialClassesLink = function(data) {
    return "".concat(getLink(data), "/classes");
};
var getSpecialClassesLinkHref = function() {
    return "".concat(getLinkHref(), "/classes");
};
var getSpecialClassesAllLink = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/classes",
        as: "".concat(getLink(data), "/classes")
    };
};
var getGtpFreeClassesAllLink = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/classes/[type]",
        as: "".concat(getLink(data), "/classes/all_classes")
    };
};
var getYoutubeCourseLink = function(data) {
    return {
        href: "/content/p/freecourses/[goalUID]",
        as: "/content/p/freecourses/".concat(data.goalUID)
    };
};
var getYoutubeLessonLink = function(data) {
    return {
        href: "/content/p/freecourses/[goalUID]/[courseTitle]/[courseUID]/[lessonUID]",
        as: "/content/p/freecourses/".concat(data.goalUID, "/").concat(data.courseTitle, "/").concat(data.courseUID, "/").concat(data.lessonUID)
    };
};
var getHrefAndAsOfAFreeCourse = function(data) {
    return {
        href: "/goal/[goalSlug]/[goalUID]/free-platform",
        as: "".concat(getLink(data), "/free-platform")
    };
};
var getHrefAndAsOfSaved = function(goal) {
    return {
        href: "".concat(getLinkHref(), "/saved"),
        as: "".concat(getLink(goal), "/saved")
    };
};
var getCoursesHref = function() {
    return "".concat(getTopicLinkHref(), "/courses");
};
var getCoursesAsPath = function(goalSlug, goalUID, topicUID) {
    return "".concat(getTopicLink({
        uid: topicUID
    }, {
        slug: goalSlug,
        uid: goalUID
    }), "/courses");
};
var _obj;
var getTopologyName = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.CATEGORY */ .OP.CATEGORY, "Category"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.GOAL */ .OP.GOAL, "Goal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.GROUP */ .OP.GROUP, "Topic Group"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.TOPIC */ .OP.TOPIC, "Topic"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.CONCEPT */ .OP.CONCEPT, "Concept"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_index__WEBPACK_IMPORTED_MODULE_1__/* .topologyLevels.SUBCONCEPT */ .OP.SUBCONCEPT, "Subconcept"), _obj);
var topology = {
    Topology: topologyModal,
    getEntityData: getEntityData,
    getLink: getLink,
    getLinkHref: getLinkHref,
    getSpecialClassesLink: getSpecialClassesLink,
    getLinkPath: getLinkPath,
    getTopicLink: getTopicLink,
    getTopicListLink: getTopicListLink,
    getSpecialClassesAllLink: getSpecialClassesAllLink,
    getHrefAndAsOfAFreeCourse: getHrefAndAsOfAFreeCourse,
    getTopicListHref: getTopicListHref,
    getSpecialClassesLinkHref: getSpecialClassesLinkHref,
    getTopicLinkHref: getTopicLinkHref,
    getHrefAndAsOfSaved: getHrefAndAsOfSaved,
    getTopologyName: getTopologyName
};
/* harmony default export */ __webpack_exports__["ZP"] = (topology);


/***/ }),

/***/ 81570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HQ": function() { return /* binding */ isLegendEducator; },
/* harmony export */   "Pp": function() { return /* binding */ getFullName; },
/* harmony export */   "dL": function() { return /* binding */ getEntityData; },
/* harmony export */   "ug": function() { return /* binding */ formatFirstName; }
/* harmony export */ });
/* unused harmony export getRelativeLink */
/* harmony import */ var _utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21848);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);


var formatFirstName = function(firstName) {
    return firstName ? firstName.toLocaleString() : "";
};
var getRelativeLink = function(user) {
    var url = "/learner/@".concat(user.username);
    if (user.is_educator || user.is_moderator) url = user.relative_link || "/@".concat(user.username);
    return url;
};
var getFullName = function(firstName, lastName) {
    return "".concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(firstName), " ").concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(lastName));
};
function userModel(userData) {
    var user = userData.author_details ? userData.author_details : userData;
    var firstName = user.first_name ? user.first_name.toLocaleString() : "";
    var lastName = user.last_name ? user.last_name : "";
    return {
        firstName: firstName,
        lastName: lastName,
        uid: user.uid,
        isFullStoryUser: user.is_full_story_user,
        name: getFullName(firstName, lastName),
        thumbnail: user.avatar_v1 || user.avatar || null,
        description: user.bio || null,
        permalink: user.permalink,
        relativeLink: getRelativeLink(user),
        averageRating: user.avg_rating,
        username: user.username.toLowerCase() || null,
        referralInfo: user.referral_info,
        followersCount: user.followers_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.followers_count) : null,
        followingCount: user.follows_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.follows_count) : null,
        lifetimeViews: user.lifetime_views ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.lifetime_views) : null,
        starRatings: user.star_ratings ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.star_ratings) : null,
        isFollowing: user.is_following,
        postsCount: user.posts_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.posts_count) : null,
        coursesCount: user.courses_count ? (0,_utils_parseNumber__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(user.courses_count) : null,
        isEducator: user.is_educator,
        isModerator: user.is_moderator,
        isVerifiedEducator: user.is_verified_educator,
        isExEducator: user.is_ex_educator,
        isEmailVerified: user.is_email_verified,
        isPhoneVerified: user.is_phone_verified,
        isProfileFilled: user.is_profile_filled,
        isPlatformEducator: user.is_platform_educator,
        isPlatinumEducator: user.is_platinum_educator,
        dedications: user.dedications,
        topicsDisplay: user.topics_display,
        stats: user.stats,
        phone: user.phone,
        email: user.email,
        state: user.state,
        country: user.country,
        language: user.language,
        canAddPlusCourse: user.can_add_plus_course,
        canAddSpecialClass: user.can_add_special_class,
        verifiedEducatorAt: user.verified_educator_at,
        liveMinutes: user.live_minutes ? Math.round(user.live_minutes / 60) : 0,
        totalWatchMins: user.total_watch_time ? Math.round(user.total_watch_time / 60) : 0,
        credentials: user.credentials,
        languages: user.languages,
        becomeEducatorAt: user.become_educator_at,
        educatorType: user.educator_type,
        educatorTypeV2: user.educator_type_v2,
        knowsAbout: user.knows_about,
        levelInfo: user.level_info || {},
        levelId: user.level_id,
        dateJoined: user.date_joined,
        ogImage: user.og_image || null,
        leaderboardMetaInfo: user.leaderboard_meta_info || null,
        avatarV1: user.avatar_v1 || null,
        avatarV2: user.avatar_v2 || null,
        oldAvatar: user.old_avatar || null,
        fallbackAvatar: user.avatar || null,
        queryID: user.queryID,
        requestID: user.requestID,
        index: user.index
    };
}
function getEntityData(data) {
    return userModel(data);
}
var isLegendEducator = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return data.uid === "WO7LDJ3Y2Z" || data.educatorType === 4;
};
var user = {
    User: userModel,
    getEntityData: getEntityData,
    isLegendEducator: isLegendEducator
};
/* harmony default export */ __webpack_exports__["ZP"] = (user);


/***/ }),

/***/ 29626:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var isEmpty = function(value) {
    return value === null || value === undefined || value === "" || Number.isNaN(value);
};
/* harmony default export */ __webpack_exports__["Z"] = (isEmpty);


/***/ }),

/***/ 21848:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var parseNumber = function(value) {
    var radix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    return value && parseInt(value, radix) || 0;
};
/* harmony default export */ __webpack_exports__["Z"] = (parseNumber);


/***/ })

}]);